import PiDialog from "./PiDialog";
import "./PiBrowseDialog.css";

interface PiBrowseDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Header pill naming an active scope — e.g. "Images only" (Phase 5). */
  scopeBadge?: React.ReactNode;
  /**
   * The dialog body, usually a `PiBrowseLayout`. Passed as an element rather
   * than children so callers can keep their data hooks inside it: MUI mounts
   * the body only while the dialog is open, which keeps selectors for absent
   * state (e.g. no selected take) from running against a closed dialog.
   */
  body: JSX.Element;
}

/**
 * Outer chrome shared by the browse-and-choose dialogs: one size expression,
 * one header treatment, one focus policy. The inner columns live in
 * `PiBrowseLayout`.
 */
export default function PiBrowseDialog(props: PiBrowseDialogProps) {
  const { open, onClose, title, scopeBadge, body } = props;

  const header = (
    <div className="pibrowsedialog-header">
      {title}
      {scopeBadge}
    </div>
  );

  return (
    <PiDialog
      open={open}
      onClose={onClose}
      // 1080x700 is the designed floor, not a cap: the frames were drawn on a
      // 1640px canvas, so pinning it there leaves the dialog looking lost on
      // a 1920. It grows with the viewport up to a ceiling sized so a Full HD
      // screen fits the 400px details pane AND five 150px tile columns, and
      // still gives way on screens too small for the floor.
      width="min(1440px, max(1080px, 74vw), 94vw)"
      height="min(900px, max(700px, 80vh), 92vh)"
      paperClassName="pibrowsedialog-root"
      bodyClassName="pibrowsedialog-body"
      header={header}
      body={body}
    />
  );
}
